import React from "react";

type EstateDetailModalProps = {
  item: any;
  onClose: () => void;
  onLike: () => void;
  formatKoreanMoney: (amount: any) => string;
};

const EstateDetailModal: React.FC<EstateDetailModalProps> = ({
  item,
  onClose,
  onLike,
  formatKoreanMoney,
}) => (
  <div
    className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center"
    onClick={onClose}
  >
    <div
      className="bg-white rounded-2xl shadow-2xl min-w-[260px] max-w-xs p-7 relative"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        onClick={onClose}
        className="absolute top-3 right-3 text-2xl text-gray-400 hover:text-gray-600"
        title="닫기"
      >
        ×
      </button>
      <div className="font-bold text-lg text-red-600 mb-1">
        {item.address || "-"}
      </div>
      <div className="text-sm text-gray-500 mb-2">
        {item.meamul_description || "-"}
      </div>
      <div className="text-base font-semibold mb-2">
        {formatKoreanMoney(item.deal_amount)}
      </div>
      <div className="text-xs text-gray-400 mb-2">ID: {item.idx}</div>
      <div className="flex flex-wrap gap-x-3 gap-y-1 mb-2">
        {Object.entries(item)
          .filter(
            ([key]) =>
              ![
                "address",
                "meamul_description",
                "deal_amount",
                "idx",
                "map_x",
                "map_y",
                "is_liked",
              ].includes(key)
          )
          .map(([key, value]) => (
            <div key={String(key)} className="text-xs text-gray-600">
              <strong>{String(key)}</strong>:{" "}
              {typeof value === "number"
                ? value.toLocaleString()
                : String(value)}
            </div>
          ))}
      </div>
      <button
        className={`text-2xl transition-colors ${
          item.is_liked ? "text-red-500" : "text-gray-300"
        }`}
        title="좋아요"
        onClick={(e) => {
          e.stopPropagation();
          onLike();
        }}
      >
        {item.is_liked ? "❤️" : "🤍"}
      </button>
    </div>
  </div>
);

export default EstateDetailModal;
